<template>
  <div>
    <v-card outlined>
      <v-card-text>
        <div class="d-flex" style="width: 400px">
          <v-btn @click="modals.new = true">Запуск синхронизации</v-btn>
        </div>
        <Table
          :headers="headers"
          :items="items"
          :loading="isLoading"
          :items-per-page="perPage"
          :server-items-length="totals"
          :page="page"
          :sort-by="sort.field"
          :sort-desc="sort.desc"
          @update:request="updateRequest"
          @update:sort-by="updateSortField"
          @update:sort-desc="updateSortDesc"
          item-key="id"
          class="elevation-1"
        >
          <template v-slot:item.created_at="{ item }">
            {{ item.created_at | dateTime }}
          </template>
          <template v-slot:item.updated_at="{ item }">
            <span v-if="['complete', 'error'].includes(item.state)">{{
              item.updated_at | dateTime
            }}</span>
          </template>
          <template v-slot:item.state="{ item }">
            <span v-if="item.state">{{
              BASE.TASK_STATE_CHOICES[item.state.toUpperCase()] || "-"
            }}</span>

            <span v-else>-</span>
          </template>
          <template v-slot:item.level="{ item }">
            {{ BASE.TASK_LEVEL_CHOICES[item.level.toUpperCase()] }}
          </template>
          <template v-slot:item.options="{ item }">
            <v-btn icon x-small>
              <v-icon @click="showInfo(item)">info</v-icon>
            </v-btn>
            <v-btn icon x-small v-if="!['complete'].includes(item.state)">
              <v-icon @click="updateStatus(item)">mdi-update</v-icon>
            </v-btn>
            <v-btn icon x-small v-if="!['complete'].includes(item.state)">
              <v-icon color="red" @click="cancelTaskModalOpen(item)"
                >mdi-cancel</v-icon
              >
            </v-btn>
            <v-btn icon x-small>
              <v-icon color="red" @click="deleteTaskModalOpen(item)"
                >mdi-delete</v-icon
              >
            </v-btn>
          </template>
        </Table>
      </v-card-text>
      <NewSyncModal :show.sync="modals.new" @save="startNewSync($event)" />
      <InfoSyncModal
        v-if="selectedTask"
        :show.sync="modals.info"
        :task="selectedTask"
        @update:dialog="(e) => (modals.info = e)"
        @update:status="(item) => handleClickInfo('updateStatus', item)"
        @update:cancel="(item) => handleClickInfo('cancelTaskModalOpen', item)"
        @update:delete="(item) => handleClickInfo('deleteTaskModalOpen', item)"
      />
      <ConfirmModal
        v-if="selectedTask"
        title="Внимание"
        :dialog.sync="modals.confirm.value"
        :confirmBtnText="modals.confirm.action.btn"
        contentClass="esh-theme adminModal"
        @confirm="performConfirm(selectedTask)"
      >
        <template #body>
          <v-col>
            {{ modals.confirm.action.text }}
          </v-col>
        </template>
      </ConfirmModal>
    </v-card>
  </div>
</template>

<script>
import {
  GET_SYNC_TASKS,
  START_SYNC_TASK,
  REVOKE_SYNC_TASK,
  DELETE_SYNC_TASK,
  UPDATE_SYNC_TASK_STATUS,
} from "@/requests/superadmin";
import { BASE } from "@/config/index";
import { Table, ConfirmModal } from "@/components/common";
import NewSyncModal from "@/views/superadmin/sync/NewSyncModal";
import InfoSyncModal from "./InfoSyncModal.vue";

const CONFIRM_DELETE = {
  text: "Вы точно хотете удалить задачу на синхронизацию?",
  btn: "Удалить задачу",
};

const CONFIRM_CANCEL = {
  text: "Вы точно хотете отменить задачу на синхронизацию?",
  btn: "Отменить задачу",
};

export default {
  name: "SyncView",
  components: { Table, NewSyncModal, ConfirmModal, InfoSyncModal },
  data() {
    return {
      BASE,
      headers: [
        { text: "#", value: "id", sortable: false },
        { text: "ID задачи", value: "task_id" },
        { text: "Дата создания (начало)", value: "created_at" },
        { text: "Дата обновления (завершена)", value: "updated_at" },
        { text: "Уровень", value: "level" },
        { text: "Состояние", value: "state" },
        { text: "Цель", value: "unit.name" },
        { text: "Прогресс", value: "progress" },
        { text: "", value: "options", sortable: false, width: 150 },
      ],
      selectedTask: null,
      items: [],
      isLoading: false,
      page: 1,
      perPage: BASE.LIMIT,
      totals: 0,
      sort: {
        field: undefined,
        desc: undefined,
      },
      modals: {
        info: false,
        edit: false,
        new: false,
        confirm: {
          value: false,
          action: CONFIRM_DELETE,
        },
      },
      inrervalIds: [],
      intervalMs: 4000,
    };
  },
  computed: {},
  methods: {
    handleClickInfo(method, task) {
      this[method](task);
      this.modals.info = false;
    },
    showInfo(item) {
      this.selectedTask = item;
      this.modals.info = true;
    },
    async updateStatus(task) {
      try {
        await UPDATE_SYNC_TASK_STATUS({ task: task.id });
        this.$notify({
          type: "success",
          text: `Статус задачи с id=${task.id} успешно обновлён`,
        });
        this.fetchItems();
      } catch (error) {
        this.$notify({
          type: "error",
          text: "Не удалось обновить статус задачи",
        });
      }
    },
    async deleteTask(task) {
      try {
        await DELETE_SYNC_TASK(task.id);
        this.$notify({
          type: "success",
          text: `Задача с id=${task.id} успешно удалена`,
        });
        this.fetchItems();
      } catch (error) {
        this.$notify({
          type: "error",
          text: "Не удалось удалить задачу синхронизации",
        });
      }
    },
    async cancelTask(task) {
      try {
        await REVOKE_SYNC_TASK({ task: task.id });
        this.$notify({
          type: "success",
          text: `Задача с id=${task.id} успешно отменена`,
        });
        this.fetchItems();
      } catch (error) {
        this.$notify({
          type: "error",
          text: "Не удалось отменить задачу синхронизации",
        });
      }
    },
    performConfirm(item) {
      if (this.modals.confirm.action === CONFIRM_DELETE) {
        this.deleteTask(item);
        return;
      } else if (this.modals.confirm.action === CONFIRM_CANCEL) {
        this.cancelTask(item);
        return;
      }
    },
    deleteTaskModalOpen(item) {
      this.selectedTask = item;
      this.modals.confirm.value = true;
      this.modals.confirm.action = CONFIRM_DELETE;
    },
    cancelTaskModalOpen(item) {
      this.selectedTask = item;
      this.modals.confirm.value = true;
      this.modals.confirm.action = CONFIRM_CANCEL;
    },
    getDataFromFirstPage() {
      this.page = 1;
      this.fetchItems();
    },
    updateSortDesc(desc) {
      this.sort.desc = Array.isArray(desc) ? desc[0] : desc;
      this.getDataFromFirstPage();
    },
    updateSortField(field) {
      this.sort.field = Array.isArray(field) ? field[0] : field;
    },
    updateRequest({ page, itemsPerPage, offset }) {
      this.perPage = itemsPerPage;
      this.page = page;
      this.fetchItems({ offset });
    },
    async startNewSync(unit) {
      try {
        await START_SYNC_TASK({ unit });
        this.fetchItems();
      } catch (error) {
        console.error(error);
        this.$notify({
          type: "error",
          text: "Не удалось создать запустить синхронизацию",
        });
      }
    },
    async fetchItems(params = {}) {
      this.isLoading = true;
      try {
        const {
          data: { results, count },
        } = await GET_SYNC_TASKS({
          limit: this.perPage,
          ...params,
        });
        this.totals = count;
        this.items = results;
        if (this.selectedTask) {
          const findEl = this.items.find((i) => i.id === this.selectedTask.id);
          if (findEl) this.selectedTask = findEl;
        }
      } catch (e) {
        console.error(e);
      }
      this.isLoading = false;
    },
  },
  mounted() {
    this.fetchItems();
    this.inrervalIds.push(setInterval(this.fetchItems, this.intervalMs));
  },
  destroyed() {
    this.inrervalIds.forEach((id) => clearInterval(id));
  },
  watch: {},
};
</script>
